<template>
  <div class="header_com">{{ titName }}</div>
</template>
<script>
export default {
  props: {
    titName: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.header_com {
  box-sizing: border-box;
  width: 100%;
  height: 50px;
  line-height: 58px;
  border-bottom: 2px solid #e4e8f0;
  border-radius: 1px 1px;
  font-family: MicrosoftYaHei;
  font-weight:700;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #282d37;
  padding-left: 25px;
  background: #fff;
  font-size: 20px;
  border-radius: 36px;
}
.textalignCenter .header_com{
  text-align: left;
  
}
</style>



// WEBPACK FOOTER //
// src/components/PageTit.vue